import { gql } from '@apollo/client'
import { useMutation } from '@apollo/client/react'
import { CreateGuildProjectMutation, CreateGuildProjectMutationVariables } from '@/types/codegen-federation'
import { GET_USER_GUILD_PROJECTS } from './useUserGuildProjectQuery'

const CREATE_GUILD_PROJECT = gql`
  mutation createGuildProject($input: createProjectInput) {
    createProject(input: $input) {
      id
      name
    }
  }
`

export const useCreateProjectMutation = () => {
  return useMutation<CreateGuildProjectMutation, CreateGuildProjectMutationVariables>(CREATE_GUILD_PROJECT, {
    refetchQueries: [GET_USER_GUILD_PROJECTS],
    errorPolicy: 'all',
  })
}
